import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useCRMTemplates(channel) {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("support-extra/crm/ListarPlantillasCRM.php", {
      token: userData.token,
      canal: channel,
    });
    setList(response);
    return response;
  }

  useEffect(() => {
    getData();
  }, [channel]);

  return { list, refresh: getData };
}
